<template>
  <div class="d-flex flex-column ml-auto mr-auto">
    <span class="text-uppercase font-xs text-gray-500">{{ $t('organization.subOrganization.subOrganizationList.organization') }}</span>
    <multiselect
      v-model="value"
      class="chooseOrganization"
      :options="options"
      placeholder="Select"
      :show-labels="false"
      label="name"
      :title="value.name"
      @input="setOrganization(value)"
      :allow-empty="false"
    ></multiselect>
  </div>
</template>

<script>
import services from '../services/services.js'
export default {
  name: 'ChooseOrganization',
  data() {
    return {
      value: {},
      userId: null,
      items: [],
      options: [],
    }
  },
  beforeMount() {
    this.setOrganizationByUrl()
  },
  mounted() {
    this.userId = this.$store.state.auth.user.id
    if (this.userId) {
      this.getOrganizationsByUser(this.userId)
    }
  },
  methods: {
    setOrganization(data) {
      this.$store.dispatch('auth/selectOrganization', data).then(() => {
        this.$router.push({ name: 'home', params: { organizationId: data.value } })
      })

      this.$store.commit('backoffice/RESET_BALANCE')
    },

    setOrganizationByUrl() {
      var urlOrg = this.$route.params.organizationId
      var vuexOrg = this.$store.state.auth.organizationId
      var data = {}
      data.value = urlOrg

      if (vuexOrg != urlOrg) {
        this.$store.dispatch('auth/selectOrganization', data).then(() => {
          this.$router.push({ name: 'home', params: { organizationId: urlOrg } })
        })
        this.$store.commit('backoffice/RESET_BALANCE')
      }
    },

    getOrganizationsByUser(userId) {
      services.getOrganizationsByUser(userId, true).then((response) => {
        this.options = response.data.data.items.map((elm) => {
          return {
            name: elm.companyName,
            value: elm.organizationId,
          }
        })
        this.value = this.options.find((elm) => elm.value == this.$route.params.organizationId)
      })
    },
  },

  computed: {
    organizationId() {
      return this.$store.state.auth.organizationId
    },
  },

  watch: {
    organizationId: {
      handler(newValue) {
        if (newValue) {
          // TODO verificar o erro no network
          this.getOrganizationsByUser(this.userId)
        }
      },
    },
  },
}
</script>

<style lang="scss">
.chooseOrganization {
  z-index: 2039;
  width: 250px;

  &.multiselect {
    background-color: transparent;
    border: none;
  }

  .multiselect__tags {
    background-color: transparent;
    padding: 0;
  }

  .multiselect__single,
  .multiselect__select:before {
    background-color: transparent;
    color: #798192;
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .multiselect__input {
    background-color: transparent;
    color: var($primary);
    font-weight: normal;
  }
}
</style>
